export default __webpack_public_path__ + "static/media/esg-conclave.ef531e04.jpg";